var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-block" },
    [
      _c("h2", [
        _vm._v(
          _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
            " Social Media Following"
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row row-clear-xs-12" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-md-6" },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-block btn-dark m-t-xs",
                attrs: { click: _vm.handleExportSocialMediaCsvCallback },
              },
              [_vm._v("\n        Export Social Media CSV\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _c("system-settings-social-media-modal"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 col-md-6" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-block btn-dark m-t-xs",
          attrs: {
            "data-toggle": "modal",
            "data-target": "#modal-import-social-media-csv",
          },
        },
        [_vm._v("\n        Import Social Media CSV\n      ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }